import { EditorType } from '@factories/app-editor-factory/enum/editor-type';

const marketsEditorConfig = {
    label: 'Markets',
    componentId: EditorType.reportingMarket,
    fieldName: 'markets'
};

const opportunitySourceEditorConfig = {
    label: 'Opportunity Source',
    componentId: EditorType.reportingOpportunitySource,
    fieldName: 'leads'
};

const departmentEditorConfig = {
    label: 'Department',
    componentId: EditorType.reportingDepartment,
    fieldName: 'divisionIds',
    additionalInfo: {
        placeholder: 'Select Departments'
    }
};

const customerEditorConfig = {
    label: 'Customer',
    componentId: EditorType.reportingCompany,
    fieldName: 'customerIds',
    additionalInfo: {
        placeholder: 'Search Customer'
    }
};

const probabilityEditorConfig = {
    label: 'Probability',
    componentId: EditorType.dropdownRanges,
    fieldName: 'probabilityValue',
    additionalInfo: {
        iconType: 'percentage',
        placeholder: 'Set Probability'
    },
    mapping: {
        probabilityValueFrom: 'probabilityValue.from',
        probabilityValueTo: 'probabilityValue.to'
    }
};

const includeArchivedEditorConfig = {
    label: 'Include Archived',
    componentId: EditorType.includeArchived,
    fieldName: 'includeArchived'
};

const includeOpportunityArchivedEditorConfig = {
    label: 'Include Archived Opportunities',
    componentId: EditorType.includeArchived,
    fieldName: 'includeOpportunityArchived',
    additionalInfo: {
        application: 'reporting'
    }
};

const estimateTypeEditorConfig = {
    label: 'Estimate Type',
    componentId: EditorType.estimateType,
    fieldName: 'estimateTypeId',
    additionalInfo: {
        application: 'reporting'
    }
};

const opportunityStatusEditorConfig = {
    label: 'Status',
    componentId: EditorType.reportingOpportunityStatus,
    fieldName: 'opportunityStatusIds',
    additionalInfo: {
        placeholder: 'Select Opportunity Status'
    }
};

const projectStartDateEditorConfig = {
    label: 'Project Start Date',
    componentId: EditorType.dateRange,
    fieldName: 'projectStartDate',
    mapping: {
        projectStartDateFrom: 'projectStartDate.from',
        projectStartDateTo: 'projectStartDate.to'
    }
};

const projectStartDateIncludeEmptyEditorConfig = {
    label: 'Project Start Date',
    componentId: EditorType.dateRange,
    fieldName: 'projectStartDate',
    mapping: {
        projectStartDateFrom: 'projectStartDate.from',
        projectStartDateTo: 'projectStartDate.to',
        projectStartDateIncludeNull: 'projectStartDate.includeEmpty'
    },
    additionalInfo: {
        allowSelectEmptyDate: true
    }
};

const projectEndDateEditorConfig = {
    label: 'Project End Date',
    componentId: EditorType.dateRange,
    fieldName: 'projectEndDate',
    mapping: {
        projectEndDateFrom: 'projectEndDate.from',
        projectEndDateTo: 'projectEndDate.to'
    }
};

const projectEndDateIncludeEmptyEditorConfig = {
    label: 'Project End Date',
    componentId: EditorType.dateRange,
    fieldName: 'projectEndDate',
    mapping: {
        projectEndDateFrom: 'projectEndDate.from',
        projectEndDateTo: 'projectEndDate.to',
        projectEndDateIncludeNull: 'projectEndDate.includeEmpty'
    },
    additionalInfo: {
        allowSelectEmptyDate: true
    }
};

const opportunityDueDateEditorConfig = {
    label: 'Opportunity Due Date',
    componentId: EditorType.dateRange,
    fieldName: 'opportunityDueDate',
    mapping: {
        opportunityDueDateFrom: 'opportunityDueDate.from',
        opportunityDueDateTo: 'opportunityDueDate.to'
    }
};

const opportunityDueDateIncludeEmptyEditorConfig = {
    label: 'Opportunity Due Date',
    componentId: EditorType.dateRange,
    fieldName: 'opportunityDueDate',
    mapping: {
        opportunityDueDateFrom: 'opportunityDueDate.from',
        opportunityDueDateTo: 'opportunityDueDate.to',
        opportunityDueDateIncludeNull: 'opportunityDueDate.includeEmpty'
    },
    additionalInfo: {
        allowSelectEmptyDate: true
    }
};

const opportunityCompetingBidderEditorConfig = {
    label: 'Competing Bidder',
    componentId: EditorType.reportingCompany,
    fieldName: 'competingBidderIds',
    additionalInfo: {
        placeholder: 'Search Competing Bidder'
    }
};

const competingBidderEditorConfig = {
    label: 'Competing Bidder',
    componentId: EditorType.reportingCompetingBidder,
    fieldName: 'competingBidderIds',
    additionalInfo: {
        placeholder: 'Search Competing Bidder'
    }
};

const potentialValueEditorConfig = {
    label: 'Potential Value',
    componentId: EditorType.dropdownRanges,
    fieldName: 'potentialValue',
    additionalInfo: {
        iconType: 'dollar',
        placeholder: 'Set Potential Value'
    },
    mapping: {
        potentialValueFrom: 'potentialValue.from',
        potentialValueTo: 'potentialValue.to'
    }
};

const salePriceEditorConfig = {
    label: 'Sell Price',
    componentId: EditorType.dropdownRanges,
    fieldName: 'sellPriceValue',
    additionalInfo: {
        iconType: 'dollar',
        placeholder: 'Set Sell Price'
    },
    mapping: {
        sellPriceFrom: 'sellPriceValue.from',
        sellPriceTo: 'sellPriceValue.to'
    }
};

const expectedResponseDateEditorConfig = {
    label: 'Expected Booking Date',
    componentId: EditorType.dateRange,
    fieldName: 'expectedResponseDate',
    mapping: {
        expectedResponseDateTo: 'expectedResponseDate.to',
        expectedResponseDateFrom: 'expectedResponseDate.from'
    }
};

const expectedResponseDateIncludeEmptyEditorConfig = {
    label: 'Expected Booking Date',
    componentId: EditorType.dateRange,
    fieldName: 'expectedResponseDate',
    mapping: {
        expectedResponseDateTo: 'expectedResponseDate.to',
        expectedResponseDateFrom: 'expectedResponseDate.from',
        expectedResponseDateIncludeNull: 'expectedResponseDate.includeEmpty'
    },
    additionalInfo: {
        allowSelectEmptyDate: true
    }
};

const companyPropertyManagerEditorConfig = {
    label: 'Property Manager',
    componentId: EditorType.reportingCompany,
    fieldName: 'companyPropertyManagerIds',
    additionalInfo: {
        placeholder: 'Search Company'
    }
};

const stateEditorConfig = {
    label: 'State',
    componentId: EditorType.state,
    fieldName: 'stateId',
    additionalInfo: {
        application: 'reporting',
        placeholder: 'Add state'
    }
};

const buildingClassEditorConfig = {
    label: 'Class',
    componentId: EditorType.reportingBuildingClass,
    additionalInfo: {
        singleSelection: true
    },
    fieldName: 'buildingClassId'
};

const companyTypeEditorConfig = {
    label: 'Company Type',
    componentId: EditorType.reportingCompanyType,
    fieldName: 'companyTypeId'
};

const legalStatusEditorConfig = {
    label: 'Legal Status',
    componentId: EditorType.reportingLegalStatus,
    fieldName: 'legalStatusId'
};

const awardedDateEditorConfig = {
    label: 'Awarded Date',
    componentId: EditorType.dateRange,
    fieldName: 'awardedDate',
    mapping: {
        awardedDateFrom: 'awardedDate.from',
        awardedDateTo: 'awardedDate.to'
    }
};

const awardedAmountEditorConfig = {
    label: 'Awarded Amount',
    componentId: EditorType.dropdownRanges,
    additionalInfo: {
        iconType: 'dollar'
    },
    fieldName: 'awardedAmount',
    mapping: {
        awardedAmountFrom: 'awardedAmount.from',
        awardedAmountTo: 'awardedAmount.to'
    }
};

const bidDateEditorConfig = {
    label: 'Bid Date',
    componentId: EditorType.dateRange,
    fieldName: 'bidDate',
    mapping: {
        bidDateFrom: 'bidDate.from',
        bidDateTo: 'bidDate.to'
    }
};

const bidAmountEditorConfig = {
    label: 'Bid Amount',
    componentId: EditorType.dropdownRanges,
    additionalInfo: {
        iconType: 'dollar',
        placeholder: 'Set Bid Amount'
    },
    fieldName: 'bidAmount',
    mapping: {
        bidAmountFrom: 'bidAmount.from',
        bidAmountTo: 'bidAmount.to'
    }
};

const opportunityCreationDateEditorConfig = {
    label: 'Opportunity Creation Date',
    componentId: EditorType.dateRange,
    fieldName: 'opportunityCreationDate',
    mapping: {
        opportunityCreationDateFrom: 'opportunityCreationDate.from',
        opportunityCreationDateTo: 'opportunityCreationDate.to'
    }
};

const opportunityCreationDateIncludeEmptyEditorConfig = {
    label: 'Opportunity Creation Date',
    componentId: EditorType.dateRange,
    fieldName: 'opportunityCreationDate',
    mapping: {
        opportunityCreationDateFrom: 'opportunityCreationDate.from',
        opportunityCreationDateTo: 'opportunityCreationDate.to',
        opportunityCreationDateIncludeNull: 'opportunityCreationDate.includeEmpty'
    },
    additionalInfo: {
        allowSelectEmptyDate: true
    }
};

const projectDueDateEditorConfig = {
    label: 'Project Due Date',
    componentId: EditorType.dateRange,
    fieldName: 'projectDueDate',
    mapping: {
        projectDueDateFrom: 'projectDueDate.from',
        projectDueDateTo: 'projectDueDate.to'
    }
};

const projectStatusEditorConfig = {
    label: 'Project Status',
    componentId: EditorType.reportingProjectStatus,
    fieldName: 'projectStatusIds'
};

const changeOrderStatusEditorConfig = {
    label: 'Change Order Status',
    componentId: EditorType.reportingChangeOrderStatus,
    fieldName: 'changeOrderStatusIds'
};

const accountEditorConfig = {
    label: 'Account',
    componentId: EditorType.reportingAccount,
    fieldName: 'accountIds',
    additionalInfo: {
        placeholder: 'Search Accounts'
    }
};

const salesPersonsEditorConfig = {
    label: 'Related Opportunities Salesperson',
    componentId: EditorType.reportingUser,
    fieldName: 'relatedOpportunitiesSalesPersonIds',
    additionalInfo: {
        placeholder: 'Search Users'
    }
};

const bidCategoriesEditorConfig = {
    label: 'Bid Categories',
    componentId: EditorType.bidCategories,
    fieldName: 'bidCategoryIds',
    additionalInfo: {
        placeholder: 'Select Bid Categories'
    }
};

const opportunityCompanyRoleEditorConfig = {
    label: 'Company Role',
    componentId: EditorType.reportingOpportunityCompanyRole,
    fieldName: 'companyRoleIds',
    additionalInfo: {
        placeholder: 'Select Company Role'
    }
};

const companyEditorConfig = {
    label: 'Companies',
    componentId: EditorType.reportingCompany,
    fieldName: 'companyIds',
    additionalInfo: {
        placeholder: 'Search Companies'
    }
};

const productTypesEditorConfig = {
    label: 'Product Types',
    componentId: EditorType.reportingOpportunityProductTypes,
    fieldName: 'productTypesIds',
    additionalInfo: {
        placeholder: 'Select Product Types'
    }
};

export {
    accountEditorConfig,
    awardedAmountEditorConfig,
    awardedDateEditorConfig,
    bidAmountEditorConfig,
    bidCategoriesEditorConfig,
    bidDateEditorConfig,
    buildingClassEditorConfig,
    changeOrderStatusEditorConfig,
    companyEditorConfig,
    companyPropertyManagerEditorConfig,
    companyTypeEditorConfig,
    competingBidderEditorConfig,
    customerEditorConfig,
    departmentEditorConfig,
    estimateTypeEditorConfig,
    expectedResponseDateEditorConfig,
    expectedResponseDateIncludeEmptyEditorConfig,
    includeArchivedEditorConfig,
    includeOpportunityArchivedEditorConfig,
    legalStatusEditorConfig,
    marketsEditorConfig,
    opportunityCompanyRoleEditorConfig,
    opportunityCompetingBidderEditorConfig,
    opportunityCreationDateEditorConfig,
    opportunityCreationDateIncludeEmptyEditorConfig,
    opportunityDueDateEditorConfig,
    opportunityDueDateIncludeEmptyEditorConfig,
    opportunitySourceEditorConfig,
    opportunityStatusEditorConfig,
    potentialValueEditorConfig,
    probabilityEditorConfig,
    productTypesEditorConfig,
    projectDueDateEditorConfig,
    projectEndDateEditorConfig,
    projectEndDateIncludeEmptyEditorConfig,
    projectStartDateEditorConfig,
    projectStartDateIncludeEmptyEditorConfig,
    projectStatusEditorConfig,
    salePriceEditorConfig,
    salesPersonsEditorConfig,
    stateEditorConfig
};
